export default __webpack_public_path__ + "static/media/WhoEatsWhat_03.645ccad6.png";